var map = {
	"./android-icon.png": "efc2",
	"./download-icon.png": "29b4",
	"./ios-icon.png": "e1b1",
	"./mac-icon.png": "6b62",
	"./qrcode-icon.png": "84da",
	"./windows-icon.png": "5c8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8fe";